// 产品类
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'
export default {
  // 获取产品类别接口
  '/sale/poroduct/getCategory': mockBaseUrl + '/sale/poroduct/getCategory',
  // 获取产品列表接口
  '/sale/poroduct/getList': mockBaseUrl + '/sale/poroduct/getList',
  // 获取产品详情接口
  '/sale/poroduct/getProductInfo': mockBaseUrl + '/sale/poroduct/getProductInfo'
}
